import React from "react";
import Doc from "../components/documentation/Doc";

const Documentation = () => {
    return (
        <>
            <Doc/>
        </>
    );
};

export default Documentation;